import isCardInvalid from './card';
import { isInvalidPhoneInput, isInvalidEmailInput } from './input';
import { ERROR_TYPES } from '../../constants/errors';
/*
  Takes mutation error
  Returns error type constant
*/
export default function getErrorType(mutationError) {
  if (isCardInvalid(mutationError)) return ERROR_TYPES.INVALID_CARD;
  if (isInvalidPhoneInput(mutationError) && isInvalidEmailInput(mutationError)) return ERROR_TYPES.INVALID_PHONE_EMAIL;
  if (isInvalidPhoneInput(mutationError)) return ERROR_TYPES.INVALID_PHONE;
  if (isInvalidEmailInput(mutationError)) return ERROR_TYPES.INVALID_EMAIL;
  if (mutationError) return ERROR_TYPES.UNKNOWN; // Error object exists but no specific handled case
  return undefined; // No error
}
